import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';
import { TractorService } from '../proxy/general/controllers/tractor.service';
import { TractorAttachmentService } from '../proxy/general/controllers/tractor-attachment.service';

FieldBuilder.setNamespace('General');

export const TRACTORATTACHMENTPERTRACTOR_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .foreignKey('tractorAttachmentId', 'Entity.TractorAttachment', TractorAttachmentService)
    .required()
    .displayFromNested('tractorAttachment.name')
    .build(),
  FieldBuilder
    .foreignKey('tractorId', 'Entity.Tractor', TractorService)
    .required()
    .display('machine.name')
    .keyField('id')
    .hideInChildForms()
    .build(),
];

export const TRACTORATTACHMENTPERTRACTOR_CONFIG = {
  entityName: 'TractorAttachmentPerTractor',
  localizationKey: 'General::Entity.TractorAttachmentPerTractor',
  fields: TRACTORATTACHMENTPERTRACTOR_FIELDS,
  permission: 'GeneralMachinesAndVehicles.TractorAttachmentPerTractors',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.General + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.MachinesAndVehicles + MENU_NAME_SUFFIX,
};
